
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_35ajp_9",
  "root-horizontal": "awsui_root-horizontal_o08jm_35ajp_41",
  "root-vertical": "awsui_root-vertical_o08jm_35ajp_46",
  "control": "awsui_control_o08jm_35ajp_51",
  "control-middle-horizontal": "awsui_control-middle-horizontal_o08jm_35ajp_58",
  "control-last-horizontal": "awsui_control-last-horizontal_o08jm_35ajp_58",
  "control-middle-vertical": "awsui_control-middle-vertical_o08jm_35ajp_61",
  "control-last-vertical": "awsui_control-last-vertical_o08jm_35ajp_61"
};
  